import { Button, Toast, Loading, Dialog, Notify } from 'vant'
import 'vant/lib/index.css'

export function registerUi(app) {
  app.use(Button)
  app.use(Toast)
  app.use(Loading)
  app.use(Dialog)
  app.use(Notify)
}
